import axios from "axios";
import { API_URL } from "../../../support/api";
import { IRole } from "../../role-and-permission/pages/roles/Role";
import { AuthModel } from "../models/AuthModel";

export const GET_USER_BY_ACCESSTOKEN_URL = `${API_URL}/auth/check`;
export const LOGIN_URL = `${API_URL}/auth/login`;
export const REGISTER_URL = `${API_URL}/auth/register`;
export const ENROLL_TWO_FACTOR_URL = `${API_URL}/auth/register/enroll-2fa`;
export const VERIFY_TWO_FACTOR_URL = `${API_URL}/auth/register/verify-2fa`;
export const REQUEST_PASSWORD_URL = `${API_URL}/auth/forgot-password`;

// Server should return AuthModel
export function login(email: string, password: string) {
	const response = axios.post<AuthModel>(LOGIN_URL, { email, password });
	return response;
}

// Self-service registration. No token is returned: the account is created in a
// pending state and must be approved by an admin. The response is always a
// generic 202 ({ success, message }) so it cannot be used to enumerate accounts.
export function register(
	email: string,
	firstname: string,
	lastname: string,
	password: string
) {
	return axios.post<{ success: boolean; message: string }>(REGISTER_URL, {
		email,
		firstname,
		lastname,
		password,
	});
}

// First step of forced 2FA enrolment for a freshly approved account. Re-checks
// the password server-side and returns an inline QR code for the TOTP secret.
export function enrollTwoFactor(email: string, password: string) {
	return axios.post<{
		value: { status: string; qr_code_inline: string; secret: string };
	}>(ENROLL_TWO_FACTOR_URL, { email, password });
}

// Second step: verifies the OTP, activates the account and returns the first
// access token.
export function verifyTwoFactorEnrollment(
	email: string,
	password: string,
	otp: string
) {
	return axios.post<{ access_token: string }>(VERIFY_TWO_FACTOR_URL, {
		email,
		password,
		otp,
	});
}

// Server should return object => { result: boolean } (Is Email in DB)
export function requestPassword(email: string) {
	return axios.post<{ result: boolean }>(REQUEST_PASSWORD_URL, { email });
}

export async function getUserByToken() {
	// Authorization head should be fulfilled in interceptor.
	// Check common redux folder => setupAxios
	const response = await axios.get<{
		value: {
			id: number;
			email: string;
			name: string;
			google_two_factor_enabled: number;
			roles: Array<IRole>;
		};
	}>(GET_USER_BY_ACCESSTOKEN_URL);
	return response.data.value;
}
